import { consumeContext } from "@/lib/consume/context"
import { Routing } from "@/lib/routing"

export const consumeRouter = consumeContext({
  Context: Routing.Context,
  provideTo: `router`,
})
